module.exports = __webpack_public_path__ + "img/svg/bitcoin-stats.ad20330f8e2eecf554bd36349408691a.svg";